import { FC, useContext } from 'react';
import { openConfirmModal } from '@mantine/modals';
import { useLingui } from '@lingui/react';
import { Text } from '@mantine/core';
import { TransButtonLink } from '../../../Atoms/Buttons';
import { Icon } from '../../../Atoms/Icons';
import { ContactDeleteFlowContext } from './ContactDeleteFlowContext';

const ContactDeleteFlow2: FC = () => {
  const { mails, isLoading, deleteMails } = useContext(ContactDeleteFlowContext);

  const { i18n } = useLingui();

  const confirmDeleteEmails = () => {
    openConfirmModal({
      size: 'sm',
      title: (
        <Text mt="md" weight="bolder" size="xl" align="center" sx={{ lineHeight: 1.2 }}>
          {i18n._('common.delete.emails.confirm.head')}
        </Text>
      ),
      closeOnEscape: true,
      transition: 'slide-down',
      labels: { confirm: 'Ja', cancel: 'Abbrechen' },
      children: <Text>{i18n._('common.delete.emails.confirm')}</Text>,
      onConfirm: deleteMails,
    });
  };

  if (!mails || mails?.length === 0) {
    return (
      <div>
        <Icon value="CHECK" /> Keine verknüpften E-Mails zu diesem Kontakt.
      </div>
    );
  }

  return (
    <div>
      <div>
        Um diesen Kontakt zu löschen, musst Du vorher die Löschung der E-Mail-Korrespondenz mit diesem Kontakt
        bestätigen.
      </div>

      <TransButtonLink
        isLoading={isLoading}
        style={{ color: '#9499a7' }}
        icon="TRASH"
        className="primary-link"
        onClick={confirmDeleteEmails}
        text={`${mails?.length ?? '0'} E-Mails löschen`}
      />
    </div>
  );
};

export default ContactDeleteFlow2;
